import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { Map } from 'immutable'
import cx from 'classnames'
import _ from 'lodash'

import config from '@config'

import hocBlock from '../../../../../../../components/Workspace/components/HocBlock'

import BisnodeCertificatesComponent from '../../BisnodeCertificates'

import { LOCALE_PREFIX, PLATINUM_CODES, GOLD_CODES, URLS, certificateCodes } from './constants'
import hocConnect from './hocConnect'

@hocBlock(config.modules.report.key)
@hocConnect
@injectIntl
export default class BisnodeCertificates extends Component {
    static propTypes = {
        data: PropTypes.object,
        entity: PropTypes.object,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
        level: PropTypes.string.isRequired,
        transformedData: PropTypes.object,
        locale: PropTypes.string.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.level !== nextProps.level) return true
        if (this.props.id !== nextProps.id) return true
        if (!_.isEqual(this.props.transformedData, nextProps.transformedData)) return true
        if (!_.isEqual(this.props.data, nextProps.data)) return true

        return false
    }

    getCertificateTooltipUrl = (code) => {
        const { locale } = this.props

        if (PLATINUM_CODES.includes(code)) return locale === 'sk' ? URLS.PLATINUM_SK : URLS.PLATINUM_CZ
        if (GOLD_CODES.includes(code)) return locale === 'sk' ? URLS.GOLD_SK : URLS.GOLD_CZ

        return ''
    }

    getCertificateTooltip = (code) => {
        const {
            intl: { formatMessage },
        } = this.props

        if (PLATINUM_CODES.includes(code) || GOLD_CODES.includes(code)) {
            return formatMessage(
                { id: `${LOCALE_PREFIX}.${code}` },
                {
                    br: <br />,
                    a: (chunks) => (
                        <a href={this.getCertificateTooltipUrl(code)} target={'_blank'} rel={'noreferrer noopener'}>
                            {chunks}
                        </a>
                    ),
                }
            )
        }

        return formatMessage({ id: `${LOCALE_PREFIX}.${code}` })
    }

    render() {
        const {
            data,
            entity,
            intl: { formatMessage },
            locale,
        } = this.props

        const entityCountry = entity.get('country', Map()).get('iso2', null)

        return (
            <div className={cx('block-bisnode-certificates')}>
                <BisnodeCertificatesComponent
                    country={entityCountry}
                    certificates={data?.data || []}
                    translates={{
                        title: formatMessage({ id: `${LOCALE_PREFIX}.title` }),
                        footer: formatMessage(
                            { id: `${LOCALE_PREFIX}.footer` },
                            {
                                a: (chunks) => (
                                    <a
                                        href={locale === 'sk' ? URLS.FOOTER_SK : URLS.FOOTER_CZ}
                                        target={'_blank'}
                                        rel={'noopener noreferrer'}
                                    >
                                        {chunks}
                                    </a>
                                ),
                            }
                        ),
                        noData: formatMessage({ id: `${LOCALE_PREFIX}.noData` }),
                        certificateCodeTranslates: certificateCodes.reduce((acc, certificateCode) => {
                            const nextContainer = acc

                            nextContainer[certificateCode] = this.getCertificateTooltip(certificateCode)

                            return nextContainer
                        }, {}),
                    }}
                />
            </div>
        )
    }
}
